import React from "react";
import PageBanner from "../../../components/sections/front/Common/PageBanner";
import OurPartners from "../../../components/sections/front/Common/OurPartners";
import SectionApply from "../../../components/sections/front/Apply/SectionApply";
import { useBanner } from "../../../providers/BannerProviders";
import { Helmet } from "react-helmet-async";

const Apply = () => {
  const { data } = useBanner();
  const applyBanner = data?.data?.find((item) => item?.bannerType === "apply");

  return (
    <>
      {applyBanner && (
        <Helmet>
          <title>{applyBanner.seoTitle}</title>
          <meta
            name="description"
            property="og:description"
            content={applyBanner.seoDescription}
          />
          <meta
            name="keywords"
            property="og:keywords"
            content={applyBanner.seoKeyword}
          />
          <meta
            name="author"
            property="og:author"
            content={applyBanner.seoAuthor}
          />
          <meta
            property="og:image"
            content="https://api.vpeters.iosx.in/storage/siteSetting/1744792455206fdfb9210eeb9358cf800c535.jpeg"
          />
          <meta
            property="og:image:url"
            content="https://api.vpeters.iosx.in/storage/siteSetting/1744792455206fdfb9210eeb9358cf800c535.jpeg"
          />
          <meta
            property="og:image:secure_url"
            content="https://api.vpeters.iosx.in/storage/siteSetting/1744792455206fdfb9210eeb9358cf800c535.jpeg"
          />
        </Helmet>
      )}
      <PageBanner title={applyBanner?.title} image={applyBanner?.image?.url} />
      <SectionApply />
      <OurPartners />
    </>
  );
};

export default Apply;
